import React from 'react'
import profile from './profile.jpg'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { Image } from 'react-bootstrap'

const Header = () => {
  return (
    <div className='mb-4'>
      <header className='App-header'>
        <div className='mb-3'>
          <h2>Mahmoud Bebars</h2>
          <p>
            Full stack Devloper...<sup>still a beginner</sup>
          </p>
        </div>

        <Image
          src={profile}
          className='profile border border-4 border-light'
          alt='profile'
          roundedCircle
        />
      </header>
    </div>
  )
}

export default Header
